module.exports = __webpack_public_path__ + "static/02_How-TULSA-procedure-prostate-treatment-works-scaled_cropped-a1606cf94bc0697553495d77d46e55f7.jpg";